import React from 'react';
import {FC} from 'react';
import {observer} from 'mobx-react-lite';
import {Button} from 'antd';
import {HeartFilled, HeartOutlined} from '@ant-design/icons';
import {logError} from '@joyrideautos/ui-logger/src/utils';

export interface FavoriteProps {
    className?: string;
    isFavorite: boolean;
    toggleFavorite?: () => (Promise<void> | void) | undefined;
}

export const Favorite: FC<FavoriteProps> = observer(({isFavorite, toggleFavorite, className = ''}) => {
    const isFavoriteClass = isFavorite ? ' active' : '';

    return (
        <Button
            className={`btn-heart center-icon ${isFavoriteClass} ${className}`}
            data-testid="auction-card-item-favorite-button"
            onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                toggleFavorite && toggleFavorite()?.catch(logError());
            }}
            shape="circle"
            size="large">
            {isFavorite ? <HeartFilled></HeartFilled> : <HeartOutlined></HeartOutlined>}
        </Button>
    );
});
